import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { FilterAmenagementByNamePipe } from 'src/app/shared/pipes/filter-amenagement-by-name/filter-amenagement-by-name.pipe';
import { ParametrageModule } from '../parametrage/parametrage.module';
import { AmenagementModalDetailComponent } from './modal/amenagement-modal-detail/amenagement-modal-detail.component';
import { AmenagementModalAjoutComponent } from './modal/amenagement-modal-ajout/amenagement-modal-ajout.component';
import { ListAmenagementComponent } from './list-amenagement/list-amenagement.component';

@NgModule({
	declarations: [
		ListAmenagementComponent,
		AmenagementModalDetailComponent,
		AmenagementModalAjoutComponent
	],
	imports: [SharedModule, ParametrageModule],
	providers: [FilterAmenagementByNamePipe]
})

export class AmenagementModule {}
